import { render, staticRenderFns } from "./SliderOverlay.vue?vue&type=template&id=904bc01a&scoped=true"
import script from "./SliderOverlay.vue?vue&type=script&lang=js"
export * from "./SliderOverlay.vue?vue&type=script&lang=js"
import style0 from "./SliderOverlay.vue?vue&type=style&index=0&id=904bc01a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904bc01a",
  null
  
)

export default component.exports